import { Component, ElementRef, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Router } from '@angular/router';
import moment from 'moment';
import 'moment/locale/pt-br';
import { ReportService } from '../../services/report-service/report.service';
import { RescueService } from '../../services/rescue-service/rescue.service';
import { SettingsService } from '../../services/setting-service/setting.service';
import { captureApiContext } from '../../services/communication-service/communication.service';
import { EditRescue } from './edit-rescue/edit-rescue';
import { statusOptions, ufOptions, kitOptions } from '../../models/index';
import { CsvRow, CsvService } from '../../services/csv-service/csv.service';
import { ModalService } from '../../services/modal/modal.service';
import { ImportPreview, LinhaInvalida, ResumoImportacao } from './import-preview/import-preview';

/** Nomes aceitos para a coluna que identifica o pedido no CSV. */
const COLUNAS_PEDIDO = ['numero_pedido', 'numero_do_pedido', 'pedido'];

@Component({
    selector: 'app-rescue-orders',
    standalone: false,
    templateUrl: './rescue-orders.html',
    styleUrl: './rescue-orders.scss',
})
export class RescueOrders implements OnInit, OnDestroy {
    private listRevision = 0;
    private listContext: (() => boolean) | null = null;

    ngOnDestroy() {
        this.listRevision++;
        this.listContext = null;
    }

    private requireCurrentList(): boolean {
        if (this.listContext?.()) return true;
        this.listContext = null;
        this.selection.clear();
        this.resumoImportacao = null;
        this.matDataSource.data = [];
        this.modalService.error(
            "A sessão ou a API mudou. Pesquise e selecione os pedidos novamente.",
            "Recarregue os pedidos",
        );
        return false;
    }
    public displayedColumns: string[] = [
        'id',
        'numero_pedido',
        'nome',
        'kit',
        'produto',
        'status',
        'data'
        // 'historico',
    ];

    queryParams: any = {};
    loading: boolean = false;
    dataInicio = new FormControl();
    dataFim = new FormControl();
    matDataSource: any = new MatTableDataSource<any>([]);
    selection = new Set<any>(); // armazena os itens selecionados
    resumoImportacao: ResumoImportacao | null = null;

    selectedStatuses = new FormControl();
    selectedUfs = new FormControl();
    selectedKits = new FormControl();

    filtersExpanded = true;
    params: any = {};

    statusOptions: any = statusOptions;
    ufOptions: any = ufOptions;
    kitOptions: any = kitOptions;

    ufSearchCtrl = new FormControl('');
    filteredUfOptions: any[] = [...ufOptions];
    ufFocused = false;

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild('ufInput') ufInput!: ElementRef<HTMLInputElement>;
    @ViewChild('ufTrigger') ufAutoTrigger!: MatAutocompleteTrigger;

    constructor(
        private rescueService: RescueService,
        public settingsService: SettingsService,
        private dialog: MatDialog,
        private reportService: ReportService,
        private router: Router,
        private csvService: CsvService,
        private modalService: ModalService
    ) {
        this.settingsService.title = 'Resgates';
        const hoje = new Date();
        this.dataInicio.setValue(new Date(hoje.getFullYear(), hoje.getMonth(), 1));
        this.dataFim.setValue(hoje);

        // Configurar formatação pt-br para os inputs
        this.setupDateFormat();

        this.matDataSource.filterPredicate = (row: any, filter: string) => {
            const nome = (row.nome || '').toLowerCase();
            const numeroPedido = String(row.numero_pedido || '').toLowerCase();
            return nome.includes(filter) || numeroPedido.includes(filter);
        };
    }

    async ngOnInit() {
      this.loading = true;

      const redirectParams = this.getRedirectParams();
      // console.log('Redirect params:', redirectParams);

      if (redirectParams) {
        // Apply filters from redirect params
        if (redirectParams.data) {
          const dataSplited = redirectParams.data.split('/');
          const dia = dataSplited[0];
          const mes = dataSplited[1];
          const ano = dataSplited[2];
          const dataFormatada = `${ano}-${mes}-${dia}`;
          this.queryParams['data'] = dataFormatada;
        }
        if (redirectParams.pedido) {
          this.queryParams['busca'] = redirectParams.pedido;
        }
      }

      await this.getRescues();

      this.loading = false;
    }

    private setupDateFormat() {
        // Configurar o datepicker para usar formato pt-br
    }

    private formatInputDate(date: Date): string {
        if (!date) return '';
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    getDisplayDate(dateControl: FormControl): string {
        const date = dateControl.value;
        return date ? this.formatInputDate(new Date(date)) : '';
    }

    getStatusClass(status: string): string {
        if (!status) return 'status-default';

        const statusLower = status.toLowerCase().trim();

        switch (statusLower) {
            case 'pendente':
                return 'status-pendente';
            case 'aprovado':
                return 'status-aprovado';
            case 'em processamento':
                return 'status-processamento';
            case 'enviado':
                return 'status-enviado';
            case 'entregue':
                return 'status-entregue';
            case 'cancelado':
                return 'status-cancelado';
            case 'cancelado pelo programa':
                return 'status-cancelado-programa';
            case 'devolvido':
                return 'status-devolvido';
            default:
                return 'status-default';
        }
    }

    // Método para tratar mudanças nos inputs de data
    onDateInputChange(event: MatDatepickerInputEvent<Date>, field: string) {
        const date = event.value;
        if (date) {
            const formattedDate = this.formatInputDate(date);
            console.log(`Data ${field} alterada:`, formattedDate);

            if (field === 'dataInicio') {
                this.dataInicio.setValue(date);
            } else if (field === 'dataFim') {
                this.dataFim.setValue(date);
            }

        }
    }

    showEditButton() {
        let isAllSelect = this.isAllSelected();
        let isAnySelectedButNotAll = this.isAnySelectedButNotAll();
        return isAllSelect || isAnySelectedButNotAll;
    }

    /**
     * A busca não trouxe pedidos. Os botões de ação continuam visíveis nesse
     * estado, mas desabilitados: a seleção por planilha casa o CSV com a lista
     * já carregada, então sem lista não há o que selecionar.
     */
    listaVazia(): boolean {
        return this.matDataSource.data.length === 0;
    }

    // ------------------------------------------------------------------
    // Processamento massivo: seleção por planilha
    // ------------------------------------------------------------------

    async onCsvSelected(arquivos: FileList | null) {
        const arquivo = arquivos && arquivos.length ? arquivos[0] : null;

        if (!arquivo) {
            return;
        }

        this.loading = true;

        try {
            const conteudo = await this.csvService.parseFile(arquivo);
            this.processarImportacao(conteudo.headers, conteudo.rows, arquivo.name, conteudo.rowLines);
        } catch (error: any) {
            this.modalService.error(
                error?.message || 'Não foi possível ler o arquivo enviado.',
                'Erro na importação',
            );
        }

        this.loading = false;
    }

    /**
     * Cruza as linhas do CSV com os pedidos já carregados e marca os encontrados.
     * O que não bater vira linha inválida, com o motivo, e pode ser baixado.
     */
    private processarImportacao(headers: string[], rows: CsvRow[], nomeArquivo: string, rowLines: number[]) {
        if (!this.requireCurrentList()) return;
        const coluna = this.csvService.findColumn(headers, COLUNAS_PEDIDO);

        if (!coluna) {
            this.modalService.warning(
                'O arquivo precisa de uma coluna com o número do pedido. ' +
                    'Nomes aceitos: numero_do_pedido, numero_pedido ou pedido.',
                'Coluna não encontrada',
            );
            return;
        }

        const porNumero = new Map<string, any>();
        this.matDataSource.data.forEach((pedido: any) => {
            porNumero.set(String(pedido.numero_pedido).trim(), pedido);
        });

        const invalidos: LinhaInvalida[] = [];
        const jaVistos = new Set<string>();
        const encontrados: any[] = [];

        rows.forEach((row, indice) => {
            const numeroLinha = rowLines[indice]!;
            const valor = (row[coluna] ?? '').trim();

            if (!valor) {
                invalidos.push({ linha: numeroLinha, valor: '', motivo: 'Número do pedido em branco' });
                return;
            }

            if (jaVistos.has(valor)) {
                invalidos.push({ linha: numeroLinha, valor, motivo: 'Repetido no arquivo' });
                return;
            }

            jaVistos.add(valor);

            const pedido = porNumero.get(valor);

            if (!pedido) {
                invalidos.push({
                    linha: numeroLinha,
                    valor,
                    motivo: 'Não encontrado na lista carregada — confira o período e os filtros',
                });
                return;
            }

            encontrados.push(pedido);
        });

        this.selection.clear();
        encontrados.forEach((pedido) => this.selection.add(pedido));

        this.resumoImportacao = {
            total: rows.length,
            validos: encontrados.length,
            invalidos,
            arquivo: nomeArquivo,
        };

        this.dialog.open(ImportPreview, {
            width: '640px',
            maxWidth: '92vw',
            data: this.resumoImportacao,
        });
    }

    baixarInvalidos() {
        if (!this.resumoImportacao || !this.resumoImportacao.invalidos.length) {
            return;
        }

        const headers = ['linha', 'numero_pedido', 'motivo'];
        const rows = this.resumoImportacao.invalidos.map((invalido) => ({
            linha: String(invalido.linha),
            numero_pedido: invalido.valor,
            motivo: invalido.motivo,
        }));

        this.csvService.download(
            `pedidos-nao-encontrados-${moment().format('YYYY-MM-DD-HHmm')}.csv`,
            this.csvService.build(headers, rows),
        );
    }

    toggleSingleRow(row: any) {
        if (this.selection.has(row)) {
            this.selection.delete(row);
        } else {
            this.selection.add(row);
        }
    }

    isAllSelected(): boolean {
        return this.selection.size === this.matDataSource.data.length;
    }

    isAnySelectedButNotAll(): boolean {
        return this.selection.size > 0 && this.selection.size < this.matDataSource.data.length;
    }

    toggleAllRows(event: any) {
        if (event.checked) {
            this.matDataSource.data.forEach((row: any) => this.selection.add(row));
        } else {
            this.selection.clear();
        }
    }

    // você pode acessar os selecionados com:
    getSelectedItems(): any[] {
        return Array.from(this.selection);
    }

    search(value: string) {
        const filterValue = value.trim().toLowerCase();

        this.matDataSource.filter = filterValue;
    }

    selectedAll() {
        this.matDataSource.data.forEach((element: any) => {
            element.selected = true;
        })
    }

    formatDate(date: any) {
        if (!date) return '';
        try {
            const formatted = moment(date).locale('pt-br').format('DD/MM/YYYY');
            return formatted;
        } catch (error) {
            console.error('Erro ao formatar data:', error);
            return '';
        }
    }

    editar(enterAnimationDuration: string, exitAnimationDuration: string): void {
        if (!this.requireCurrentList()) return;
        const dialogRef = this.dialog.open(EditRescue, {
            width: '440px',
            maxWidth: '92vw',
            enterAnimationDuration,
            exitAnimationDuration,
            data: { rescues: Array.from(this.selection), selectionIsCurrent: this.listContext },
        });

        dialogRef.afterClosed().subscribe(async () => {
            await this.ngOnInit();
        });
    }

    /** Abre o histórico já filtrado por este pedido — "quem mexeu neste pedido?". */
    verHistorico(rescue: any) {
        this.router.navigate(['/home/communications-history'], {
            queryParams: { pedido: rescue.numero_pedido },
        });
    }

    downloadReport() {
        this.applyFilters();
        this.loading = true;
        let report = this.reportService.downloadRescuesReport(this.params);
        console.log('Report: ', report);
        this.loading = false;

    }

    async onDateChange() {
        if (this.dataInicio.value && this.dataFim.value) {
            await this.getRescues();
        }
    }

    async getRescues(){
        const revision = ++this.listRevision;
        const context = captureApiContext(this.settingsService);
        this.listContext = null;
        this.selection.clear();
        this.resumoImportacao = null;
        this.matDataSource.data = [];
        this.loading = true;
        this.applyFilters();
        try {
            const result = await this.rescueService.getRescues(this.params);
            if (revision !== this.listRevision) return;
            if (!context()) {
                this.requireCurrentList();
                return;
            }
            this.matDataSource.data = result;
            this.listContext = () => revision === this.listRevision && context();
            if (this.queryParams['busca']) this.search(this.queryParams['busca']);
            this.matDataSource.paginator = this.paginator;
        } catch (error: any) {
            if (revision === this.listRevision) this.modalService.error(
                error?.message || 'Não foi possível consultar os pedidos.', 'Erro ao carregar',
            );
        } finally {
            if (revision === this.listRevision) this.loading = false;
        }
    }

    // Métodos para os filtros
    applyFilters() {
        const kitsSelecionados = this.selectedKits.value || [];
        const statusSelecionados = this.selectedStatuses.value || [];
        const ufsSelecionadas = this.selectedUfs.value || [];

        // Garantir que as datas nunca sejam null
        const dataInicio = this.dataInicio.value || new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        const dataFim = this.dataFim.value || new Date();

        this.params = {
            cpf: this.settingsService.user.cpf,
            dataInicio: moment(dataInicio).format('YYYY-MM-DD'),
            dataFim: moment(dataFim).format('YYYY-MM-DD'),
            kits: kitsSelecionados,
            status: statusSelecionados,
            ufs: ufsSelecionadas
        }

        // console.log('queryParams:', this.queryParams);
        if (this.queryParams && this.queryParams['data'] && this.queryParams['busca']) {
            this.params['dataInicio'] = moment(this.queryParams['data']).format('YYYY-MM-DD');
            this.params['dataFim'] = moment(this.queryParams['data']).format('YYYY-MM-DD');
            this.params['search'] = this.queryParams['busca'];
        }
    }

    clearFilters() {
        // Limpar apenas filtros de select, mantendo datas
        this.selectedStatuses.setValue([]);
        this.selectedUfs.setValue([]);
        this.selectedKits.setValue([]);
        this.ufSearchCtrl.setValue('');
        this.filteredUfOptions = [...this.ufOptions];
        this.queryParams = {};
        window.location.search = '';

        // Recarregar dados com as datas padrão
        this.getRescues();
    }

    private removeAccents(str: string): string {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    filterUfs() {
        const term = this.removeAccents((this.ufSearchCtrl.value || '').trim().toLowerCase());
        this.filteredUfOptions = this.ufOptions.filter((u: any) =>
            this.removeAccents(u.description.toLowerCase()).includes(term) ||
            this.removeAccents(u.value.toLowerCase()).includes(term)
        );
    }

    addUf(event: any) {
        const uf = event.option.value;
        const current = this.selectedUfs.value || [];
        if (current.includes(uf)) {
            this.selectedUfs.setValue(current.filter((v: string) => v !== uf));
        } else {
            this.selectedUfs.setValue([...current, uf]);
        }
        this.ufSearchCtrl.setValue('');
        if (this.ufInput) {
            this.ufInput.nativeElement.value = '';
        }
        this.filteredUfOptions = [...this.ufOptions];
        setTimeout(() => {
            this.ufInput?.nativeElement.focus();
            this.ufAutoTrigger?.openPanel();
        });
    }

    isUfSelected(value: string): boolean {
        return (this.selectedUfs.value || []).includes(value);
    }

    removeUf(uf: string) {
        const current = this.selectedUfs.value || [];
        this.selectedUfs.setValue(current.filter((v: string) => v !== uf));
    }

    clearUfSearch() {
        setTimeout(() => {
            if (document.activeElement === this.ufInput?.nativeElement) return;
            this.ufSearchCtrl.setValue('');
            if (this.ufInput) {
                this.ufInput.nativeElement.value = '';
            }
            this.filteredUfOptions = [...this.ufOptions];
            this.ufFocused = false;
        }, 200);
    }

    hasActiveFilters(): boolean {
        return !!(this.dataInicio.value ||
                  this.dataFim.value ||
                  (this.selectedStatuses.value && this.selectedStatuses.value.length > 0) ||
                  (this.selectedUfs.value && this.selectedUfs.value.length > 0) ||
                  (this.selectedKits.value && this.selectedKits.value.length > 0));
    }

    // Toggle para expandir/recolher filtros
    toggleFilters() {
        this.filtersExpanded = !this.filtersExpanded;
    }

    statusDescricao(data: any) {
        const status = data.toUpperCase();
        if (status === 'CANCELADO PELO PROGRAMA') {
            return 'CANCELADO';
        }
        return status;
    }

    getStatusColor(status: string) {
        switch (status) {
            case 'PENDENTE':
                return '#f39c12';
            case 'APROVADO':
                return '#1E8449';
            case 'ENVIADO':
                return '#2471A3';
            case 'ENTREGUE':
                return '#2ECC71';
            case 'CANCELADO':
                return '#E74C3C';
            case 'CANCELADO_PELO_PROGRAMA':
                return '#FF0202';
            default:
                return '#000000';
        }
    }

    getRedirectParams(): any {
        const url = window.location.search;
        const params = new URLSearchParams(url);
        return Object.fromEntries(params);
    }
}
